const fetchUsersListRed = ( state = {
    status: 'init',
    isFetching: false,
    showLoading: true,
    loadingMessage: 'Initializing...',
    loadingMessage2: 'Please wait, this won\'t take long..'
}, action ) => {
    if( action.type == 'FETCH_USERS_LIST' ){
        console.log('HERE IS THE USERS LIST RED ACTION: ', action.payload.status);
        switch ( action.payload.status ){
            case 'init':
                return state;
            case 'fetching':
                return Object.assign( {}, state, {
                    status: 'fetching',
                    showLoading: true,
                    loadingMessage: 'Loading...',
                    loadingMessage2: 'Getting the list of users...',
                    isFetching: true,
                    rootAccountAlias: action.payload.rootAccountAlias,
                    bearerToken: action.payload.bearerToken
                });
            case 'pendingUsers':
                console.log('Pending User: Reducer dispatched');
                return Object.assign( {}, state, {
                    pendingUser: action.payload.pendingUser
                })
            case 'succeed':
                console.log('User list request succeed.. / action:', action);
                return Object.assign( {}, state, {
                    status: 'succeed',
                    showLoading: false,
                    isFetching: false,
                    data: action.payload.data,
                    isAccountAdmin: action.payload.isAccountAdmin
                });
            case 'failed':
                return Object.assign( {}, state, {
                    status: 'failed',
                    showLoading: false,
                    isFetching: false,
                    hasFailed: true,
                    data: action.data
                });
            default:
                return state
        }
    }else{
        return state;
    }
};

export default fetchUsersListRed;


/** WEBPACK FOOTER **
 ** ./src/reducers/fetchUsersListRed.js
 **/